import { useMediaQuery } from "react-responsive";
import './index.scss'
import PrivateCreditHead from './modules/PrivateCreditHead'
import PrivateCreditContent from './modules/PrivateCreditContent'
import PrivateCreditFoot from './modules/PrivateCreditFoot'


const Home = () => {
 const isDesktop = useMediaQuery({ minWidth: 769 });

 return (
  <div className={`private-credit`}>
    <PrivateCreditHead />

    <PrivateCreditContent />

    <PrivateCreditFoot />

  </div>
 )
}

export default Home